import { render, staticRenderFns } from "./ConfigChips.vue?vue&type=template&id=518eb3c7&scoped=true&"
import script from "./ConfigChips.vue?vue&type=script&lang=js&"
export * from "./ConfigChips.vue?vue&type=script&lang=js&"
import style0 from "./ConfigChips.vue?vue&type=style&index=0&id=518eb3c7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518eb3c7",
  null
  
)

export default component.exports